import styled from 'styled-components';
import { container, flexPosition } from '../../styles/mixins';

export const MenuItem = styled.div`
  ${container()}
  margin-top: 50px;
  padding-bottom: 50px;
`;

export const Content = styled.div`
  ${container()}
  ${flexPosition({ align: 'center', justify: 'space-between' })}
`;

export const Box = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  width: 100%;
  padding: 30px;
  margin-top: 35px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.05);
`;

export const NoResult = styled.li`
  list-style: none;
  font-style: italic;
  width: 100%;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/screens/GlobalVariations/style.js